<template>
  <SectionLayout :section-title="sectionTitle" >
    <template #header>
      <div class="start-guide__heading d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <p class="heading-h5-16-medium text-light-high mr-3">
            {{ sectionTitle }}
          </p>
          <span class="start-guide__progress">
            <span class="start-guide__progress-process" :style="processDynamicStyle" :class="processDynamicClass"></span>
          </span>
          <svg class="ml-12px" v-if="guideStatus == 'done'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.36634 15.0641C9.28824 15.1422 9.1616 15.1422 9.0835 15.0641L5.92314 11.9037C5.72788 11.7085 5.41129 11.7085 5.21603 11.9037L4.35355 12.7662C4.15829 12.9615 4.15829 13.278 4.35355 13.4733L8.51781 17.6376C8.90834 18.0281 9.5415 18.0281 9.93203 17.6376L19.6464 7.92314C19.8417 7.72788 19.8417 7.41129 19.6464 7.21603L18.784 6.35355C18.5887 6.15829 18.2721 6.15829 18.0769 6.35355L9.36634 15.0641Z" fill="#00C753" />
          </svg>
          <span v-else class="ml-1 body-12-regular txt-dark-low-contrast">{{ processPercent }}</span>
        </div>
        <div v-if="currentIndex > 0" class="start-guide__header-action d-flex align-items-center justify-content-center" :class="{'hoverable': currentIndex > 0}" @click="clickBack">
          <span class="start-guide__header-action-text clickable paragraph-12-medium text-light-high">{{ backText }}</span>
        </div>
      </div>
    </template>
    <template #default>
      <div class="bg-light1 border-radius d-flex justify-content-between start-guide__content">
        <template v-if="currentIndex < steps.length">
          <template v-for="(step, i) in steps">
            <div class="justify-content-between flex-grow-1 step" :key="i" v-show="i === currentIndex">
              <!-- Left -->
              <div class="pl-3 d-flex flex-column justify-content-between" >
                <div>
                  <p class="start-guide__title">
                    <span class="d-flex justify-content-center align-items-center start-guide__title-dot">
                      <svg v-if="checkSteps[i]" width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.00016 3.33331C4.3335 3.33331 1.3335 6.33331 1.3335 9.99998C1.3335 13.6666 4.3335 16.6666 8.00016 16.6666C11.6668 16.6666 14.6668 13.6666 14.6668 9.99998C14.6668 6.33331 11.6668 3.33331 8.00016 3.33331ZM6.66683 13.3333L3.3335 9.99998L4.2735 9.05998L6.66683 11.4466L11.7268 6.38665L12.6668 7.33331L6.66683 13.3333Z" fill="#00C753" />
                      </svg>

                      <svg v-else xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.2286 2.22879C4.3114 0.145987 7.68827 0.145987 9.77107 2.22879C11.8539 4.31159 11.8539 7.68845 9.77107 9.77125C7.68827 11.8541 4.3114 11.8541 2.2286 9.77125C0.145804 7.68845 0.145804 4.31159 2.2286 2.22879Z" fill="#EEEFF1" />
                      </svg>
                    </span>

                    <span class="start-guide__value heading-h6-14-medium text-light-high">
                      {{ step.title }}
                    </span>
                  </p>
                  <p class="mt-half mb-2 paragraph-14-regular text-dark6 start-guide__desc">{{ step.desc }}</p>
                </div>

                <div class="d-flex align-items-center">
                  <div class="border-radius mr-2 clickable start-guide__action d-flex align-items-center" @click="clickAction">
                    <span class="action-text paragraph-12-medium text-light-high">{{ step.btnText }}</span>
                  </div>
                  <div class="clickable border-radius d-flex align-items-center start-guide__skip" @click="clickSkip">
                    <span class="paragraph-12-medium text-light-high">{{ skipText }}</span>
                  </div>
                </div>
              </div>
              <!-- Right -->
              <img :src="step.img" />
            </div>
          </template>
        </template>
        <template v-else-if="guideStatus == 'done'">
          <div class="d-flex flex-column justify-content-between">
            <div>
              <p class="button-14-medium txt-dark-high-contrast">
                {{ $t("dashboard.doneGuideTitle") }}
              </p>
              <p class="mt-half mb-2 paragraph-14-regular text-dark6 start-guide__desc">{{ $t("dashboard.doneGuideDesc") }}</p>
            </div>
            <div class="d-flex align-items-center">
              <div class="border-radius mr-3 clickable start-guide__action d-flex align-items-center" @click="closeGuide">
                <span class="paragraph-12-medium text-light-high">{{ $t("generals.close") }}</span>
              </div>
            </div>
          </div>
          <img :src="doneImg" />
        </template>
        <template v-else>
          <div class="d-flex flex-column justify-content-between">
            <div>
              <p class="button-14-medium txt-dark-high-contrast">
                {{ $t("dashboard.notDoneGuideTitle") }}
              </p>
              <p class="mt-half mb-2 paragraph-14-regular text-dark6 start-guide__desc">{{ $t("dashboard.notDoneGuideDesc") }}</p>
            </div>
            <div class="d-flex align-items-center">
              <div class="border-radius mr-2 clickable bg-dark-blue-300 d-flex align-items-center start-guide__back" @click="goBack">
                <span class="paragraph-12-medium">{{ $t("dashboard.notDoneGuideButton") }}</span>
              </div>
            </div>
          </div>
          <img :src="notDoneImg" />
        </template>
      </div>
      <Modal v-if="showVideo" :active="showVideo" mClass="p-0" padding="p-0" @cancel="closeVideoModal" @container="closeVideoModal">
        <div class="video__wrapper">
          <iframe class="border-radius" width="100%" height="100%" src="https://www.youtube.com/embed/zH8LZ5GaCaU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </Modal>
    </template>
  </SectionLayout>
</template>

<script>
import SectionLayout from "./SectionLayout.vue";
import { mapGetters, mapActions } from "vuex";
import Cookie from "@/utils/cookie";

const CheckSteps = {
  DONE: 1,
  NOT_DONE: 0
};

const YOUTUBE_EMBED_SRC = "https://www.youtube.com/embed/zH8LZ5GaCaU";

// Tạm lưu step ở cookie vì Backend không lưu được
export default {
  name: "QuickStartGuide",
  components: {
    SectionLayout
  },
  data: () => ({
    currentIndex: 0,
    processPercent: "0%",
    checkSteps: [],
    guideStatus: "",
    guideCookie: null,
    showVideo: false,
    videoSource: YOUTUBE_EMBED_SRC
  }),
  computed: {
    ...mapGetters("account", {
      shopifyDomain: "shopifyDomain"
    }),
    sectionTitle() {
      return this.$t("dashboard.quickStartGuide");
    },
    backText() {
      return this.$t("onboardingStep.toolbar.button");
    },
    skipText() {
      return this.$t("general.skip");
    },
    steps() {
      return [
        {
          img: require("@/core/assets/new-dashboard/overview.svg"),
          title: this.$t("dashboard.step0Title"),
          desc: this.$t("dashboard.step0Desc"),
          btnText: this.$t("dashboard.step0BtnText"),
        },
        {
          img: require("@/core/assets/new-dashboard/create-page.svg"),
          title: this.$t("dashboard.step1Title"),
          desc: this.$t("dashboard.step1Desc"),
          btnText: this.$t("dashboard.step1BtnText"),
        },
        {
          img: require("@/core/assets/new-dashboard/responsive.svg"),
          title: this.$t("dashboard.step2Title"),
          desc: this.$t("dashboard.step2Desc"),
          btnText: this.$t("dashboard.step2BtnText"),
        },
        {
          img: require("@/core/assets/new-dashboard/account-settings.svg"),
          title: this.$t("dashboard.step3Title"),
          desc: this.$t("dashboard.step3Desc"),
          btnText: this.$t("dashboard.step3BtnText"),
        },
        {
          img: require("@/core/assets/new-dashboard/unlock-features.svg"),
          title: this.$t("dashboard.step4Title"),
          desc: this.$t("dashboard.step4Desc"),
          btnText: this.$t("dashboard.step4BtnText"),
        }
      ];
    },
    notDoneImg() {
      return require("@/core/assets/new-dashboard/not-done-start-guide.svg");
    },
    doneImg() {
      return require("@/core/assets/new-dashboard/done-start-guide.svg");
    },
    processDynamicStyle() {
      return {
        width: this.processPercent
      };
    },
    processDynamicClass() {
      return this.guideStatus;
    },
    currentStep() {
      if (this.currentIndex == this.steps.length) {
        return false;
      }
      return this.steps[this.currentIndex];
    }
  },
  created() {
    let guideCookie = Cookie.get("quickGuideStep");
    let startedGuideStep = false;
    if (guideCookie != null) {
      this.guideCookie = JSON.parse(guideCookie);
      if (this.guideCookie[this.shopifyDomain]) {
        startedGuideStep = this.guideCookie[this.shopifyDomain];
      }
    } else {
      this.guideCookie = {};
    }

    if (!startedGuideStep) {
      const check = this.steps.map(() => CheckSteps.NOT_DONE);
      startedGuideStep = {
        check,
        index: 0
      };
    }

    this.checkSteps = startedGuideStep.check;
    this.goToStep(startedGuideStep.index);
  },
  methods: {
    ...mapActions("page", {
      createPageWithOneTap: "createPageWithOneTap"
    }),
    async clickAction() {
      const index = this.currentIndex;
      this.checkSteps[index] = CheckSteps.DONE;
      this.goToStep(index + 1, [0, 2].includes(index));
      switch (index) {
        case 0:
          window.open("https://help.gempages.net/articles/introduction-to-gempages", "_blank");
          break;
        case 1:
            // eslint-disable-next-line no-case-declarations
            const type = "subpages";
            this.createPageWithOneTap({type});
          break;
        case 2:
          window.open("https://help.gempages.net/articles/create-responsive-web-design", "_blank");
          break;
        case 3:
          this.$router.push({ name: "AccountSettings" });
          break;
        case 4:
          this.$router.push({ name: "Pricing" });
          break;
      }
    },
    clickSkip() {
      this.goToStep(this.currentIndex + 1);
    },
    clickBack() {
      this.goToStep(this.currentIndex - 1);
    },
    goToStep(index, isSkip = true) {
      const isDone = this.checkSteps.every(check => check == CheckSteps.DONE);
      if (isDone) {
        this.guideStatus = "done";
      } else if (index >= this.checkSteps.length) {
        this.guideStatus = "not-done";
      } else {
        this.guideStatus = "";
      }

      this.setCookie(index);
      this.setProcessPercent();
      if (isSkip) {
        this.currentIndex = parseInt(index);
      }
    },
    setCookie(index) {
      const guideData = {
        index,
        check: this.checkSteps
      };
      this.guideCookie[this.shopifyDomain] = guideData;
      const dataString = JSON.stringify(this.guideCookie);
      Cookie.set("quickGuideStep", dataString);
    },
    setProcessPercent() {
      const doneLength = this.checkSteps.filter(item => item).length;
      const allLength = this.checkSteps.length;
      this.processPercent = `${Math.ceil((doneLength / allLength) * 100)}%`;
    },
    goBack() {
      for (let i in this.checkSteps) {
        if (!this.checkSteps[i]) {
          return this.goToStep(i);
        }
      }
    },
    async closeGuide() {
      this.$store.dispatch("dashboard/closeQuickStartGuide");
    },
    closeVideoModal() {
      this.showVideo = false;
    }
  }
};
</script>

<style lang="scss">
$height-progress: 6px;

@mixin absolute-center-Y {
  top: 50%;
  transform: translateY(-50%);
}

.start-guide {
  &__title {
    position: relative;

    &-dot {
      position: absolute;
      right: calc(100% + 10px);

      @include absolute-center-Y;
    }
  }

  &__heading {
    height: 32px;
  }

  &__header-action {
    @include trans-all;
    height: 32px;
    padding: 0 24px;
    border-radius: 3px;
    &.hoverable {
      &:hover {
        background-color: $light3;
      }
    }
    &-text {
      line-height: 14px !important;
    } 
  }

  &__desc {
    max-width: 379px;
    line-height: 21px !important;
  }

  &__content {
    min-height: 118px;

    .step {
      display: flex;
    }
  }

  &__progress {
    width: 289px;
    height: $height-progress;
    position: relative;
    background-color: map-get($light-grey, "200");

    @media screen and (max-width: 1200px) {
      width: 250px;
    }
    @media screen and (max-width: 1140px) {
      width: 200px;
    }

    &-process {
      height: $height-progress;
      background-color: map-get($primary, "300");
      position: absolute;
      top: 0;
      left: 0;
      transition-duration: 0.3s;

      &.done {
        background-color: map-get($accent-green-new, "300");
      }

      &.not-done {
        background-color: map-get($accent-amber, "300");
      }
    }
  }

  &__action, &__skip, &__back {
    @include trans-all;
    padding: 0 24px;
    height: 32px;
  }

  &__back {
    color: map-get($light-text, "low-contrast")
  }

  &__action {
    background-color: $light3;
    &:hover {
      background-color: $mono3;
      .action-text {
        color: $light1 !important;
      }
    }
  }

  &__skip {
    &:hover {
      background-color: $light3;
    }
  }
}

.animation {
  &__dot {
    height: 14px;
    width: 14px;
    border: 1px solid map-get($primary, "300");
    border-radius: 50%;
    position: relative;
  }

  &__wrapper {
    position: absolute;
    top: -2px;
    left: -2px;
    // transform: translate(-50%, -50%);

    border-radius: 50%;

    background-color: map-get($primary, "500");

    animation-name: animation-border;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    width: 16px;
    height: 16px;
  }
}

@keyframes animation-border {
  from {
    transform: scale(0.8);
    opacity: 0.2;
  }

  to {
    transform: scale(1.5);
    opacity: 0.5;
  }
}

.video {
  &__wrapper {
    width: 889px;
    height: 500px;
  }
}
</style>
